import ShopArticlesListByCategoryModelBase from '../_generated/modelBases/shop-articles-list-by-category-model-base';

export default class ShopArticlesListByCategoryModel extends ShopArticlesListByCategoryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
